import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

type FindingDataStateProps = {
  levelName: string | null;
};

/**
 * Loading state shown while auto-navigating to find the first level with data.
 * Provides a friendly experience instead of showing an empty state during search.
 */
export function FindingDataState({ levelName }: FindingDataStateProps) {
  return (
    <div
      className="rounded-md border border-primary-200 bg-primary-50 p-6"
      data-testid="finding-data-state"
    >
      <div className="flex items-center gap-3">
        <MagnifyingGlassIcon className="size-5 animate-pulse text-primary-600" />
        <div>
          <h3 className="text-base font-semibold text-primary-900">
            Finding available data...
          </h3>
          <p className="mt-1 text-sm text-primary-800">
            {levelName
              ? `Checking ${levelName} level for available data.`
              : 'Searching for the best data to display.'}
          </p>
        </div>
      </div>
    </div>
  );
}
